if (!customElements.get('e8-belt-fit')) {
  customElements.define('e8-belt-fit', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.dialog = this.querySelector('dialog');
      if (!this.root || !this.dialog) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-e8-fit-trigger]');
        if (!trigger || !this.root.contains(trigger)) return;
        event.preventDefault();
        this.opener = trigger;
        this.followChart = false;
        this.dialog.showModal();
      }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('[data-e8-fit-close]') || event.target === this.dialog) this.dialog.close();
        const chartLink = event.target.closest('[data-e8-full-chart]');
        if (!chartLink) return;
        event.preventDefault();
        const chart = document.getElementById(chartLink.hash.slice(1));
        this.followChart = true;
        this.dialog.close();
        if (!chart) return;
        chart.open = true;
        requestAnimationFrame(() => {
          chart.querySelector('summary')?.focus({ preventScroll: true });
          chart.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      }, { signal });
      this.dialog.addEventListener('close', () => {
        if (!this.followChart) (this.opener?.isConnected ? this.opener : this.root.querySelector('[data-e8-fit-trigger]'))?.focus({ preventScroll: true });
      }, { signal });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.events?.abort();
    }
  });
}
